export function FusebaseLogoSmall() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.7822 0V2.14571H21.8531V5.23865H24V0H18.7822Z" fill="#262626" />
      <path d="M4.07454e-10 5.22512H2.14692V2.15934H5.2416V0.0136307H4.07454e-10V5.22512Z" fill="#262626" />
      <path d="M18.7549 21.8407H21.853V18.7715H23.9999V23.9864H18.7549V21.8407Z" fill="#262626" />
      <path d="M2.14692 18.758H0V24H5.21783V21.8543H2.14692V18.758Z" fill="#262626" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.474 6.10778H13.4804L18.7254 15.1931L17.2239 17.7903H6.73049L5.229 15.1931L10.474 6.10778Z"
        fill="#262626"
      />
    </svg>
  );
}
